<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <span *ngIf="householdId > 0">
        <mat-icon>edit</mat-icon> Edit Household <span>OHA Id: {{householdId}}</span>
      </span>
      <span *ngIf="householdId == 0">
        <mat-icon>add</mat-icon> Add Household
      </span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">&nbsp;</div>
</div>

<div *ngIf="!loading">
  <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
    <mat-tab label="Household">
      <br />
      <form [formGroup]="householdForm" class="form-field-full">
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Household &amp; Water Information</span>
              </mat-card-title>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="33" fxFlex.lt-sm="100">
                  Eligible:
                  <mat-checkbox formControlName="eligible"></mat-checkbox>
                </div>
                <div fxFlex="33" fxFlex.lt-sm="100">
                  Shared Well:
                  <mat-checkbox formControlName="sharedWell"></mat-checkbox>
                </div>
                <div fxFlex="33" fxFlex.lt-sm="100">
                  County Tested Well:
                  <mat-checkbox formControlName="countyTestedWell"></mat-checkbox>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="33" fxFlex.lt-sm="100">
                  Request Confidentiality:
                  <mat-checkbox formControlName="requestedConfidentiality"></mat-checkbox>
                </div>
                <div fxFlex="33" fxFlex.lt-sm="100">
                  Water Treatment Provided:
                  <mat-checkbox formControlName="waterTreamentProvided"></mat-checkbox>
                </div>
                <div fxFlex="33" fxFlex.lt-sm="100">
                  Bottled Water Provided:
                  <mat-checkbox formControlName="bottledWaterProvided"></mat-checkbox>
                </div>

              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="25" fxFlex.lt-sm="100">
                  Pregnancy In Household:
                  <mat-checkbox formControlName="pregnancyInHousehold"></mat-checkbox>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  Infants (2 and Under) In Household:
                  <mat-checkbox formControlName="infantsInHousehold"></mat-checkbox>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  Translation Needed:
                  <mat-checkbox formControlName="translationNeeded"></mat-checkbox>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  <mat-radio-group formControlName="residence" fxLayoutGap="4px grid">
                    <mat-radio-button value="Rent">Rent</mat-radio-button>
                    <br />
                    <mat-radio-button value="Own">Own</mat-radio-button>
                    <br />
                    <mat-radio-button value="Other">Other</mat-radio-button>&nbsp;
                    <input matInput placeholder="Residence Other" formControlName="residenceOther" *ngIf="householdForm.get('residence').value == 'Other'">
                  </mat-radio-group>
                </div>
              </div>

              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="40" fxFlex.lt-sm="100">
                  Declined LUBGWMA Testing Services:
                  <mat-checkbox formControlName="declinedLubgwmaTestingServices"></mat-checkbox>
                  <br /><small class="text-red-400">Make sure all prior results letters have been sent before checking this box</small>
                </div>

                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTestingServices').value">
                  <mat-form-field>
                    <mat-label>Date of Decline</mat-label>
                    <input id="dateOfDecline" name="dateOfDecline" formControlName="dateOfDecline" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerDateOfDecline" />
                    <mat-datepicker-toggle matSuffix [for]="datepickerDateOfDecline"></mat-datepicker-toggle>
                    <mat-datepicker #datepickerDateOfDecline>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTestingServices').value">
                  <mat-form-field>
                    <mat-label>Type of Decline</mat-label>
                    <mat-select id="typeOfDecline" name="typeOfDecline" formControlName="typeOfDecline">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of householdService.typeOfDeclineOptions" value="{{item}}">{{item}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTestingServices').value">
                  <mat-form-field>
                    <mat-label>Date of Further Outreach</mat-label>
                    <input id="dateOfFurtherOutreach" name="dateOfFurtherOutreach" formControlName="dateOfFurtherOutreach" placeholder="mm/dd/yyyy" matInput
                      [matDatepicker]="datepickerDateOfFurtherOutreach" />
                    <mat-datepicker-toggle matSuffix [for]="datepickerDateOfFurtherOutreach"></mat-datepicker-toggle>
                    <mat-datepicker #datepickerDateOfFurtherOutreach>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <br /> <br /><br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="40" fxFlex.lt-sm="100">
                  Declined LUBGWMA Treatment Services:
                  <mat-checkbox formControlName="declinedLubgwmaTreatmentServices"></mat-checkbox>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTreatmentServices').value">
                  <mat-form-field>
                    <mat-label>Date of Decline</mat-label>
                    <input id="treatmentDateOfDecline" name="treatmentDateOfDecline" formControlName="treatmentDateOfDecline" placeholder="mm/dd/yyyy" matInput
                      [matDatepicker]="datepickerTreatmentDateOfDecline" />
                    <mat-datepicker-toggle matSuffix [for]="datepickerTreatmentDateOfDecline"></mat-datepicker-toggle>
                    <mat-datepicker #datepickerTreatmentDateOfDecline>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTreatmentServices').value">
                  <mat-form-field>
                    <mat-label>Type of Decline</mat-label>
                    <mat-select id="treatmentTypeOfDecline" name="treatmentTypeOfDecline" formControlName="treatmentTypeOfDecline">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of householdService.typeOfDeclineOptions" value="{{item}}">{{item}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100" *ngIf="householdForm.get('declinedLubgwmaTreatmentServices').value">
                  <mat-form-field>
                    <mat-label>Date of Further Outreach</mat-label>
                    <input id="treatmentDateOfFurtherOutreach" name="treatmentDateOfFurtherOutreach" formControlName="treatmentDateOfFurtherOutreach" placeholder="mm/dd/yyyy" matInput
                      [matDatepicker]="datepickerTreatmentDateOfFurtherOutreach" />
                    <mat-datepicker-toggle matSuffix [for]="datepickerTreatmentDateOfFurtherOutreach"></mat-datepicker-toggle>
                    <mat-datepicker #datepickerTreatmentDateOfFurtherOutreach>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <br />
              <br /><br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Age 15 And Below" formControlName="age15AndBelow">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Age 16 And Above" formControlName="age16AndAbove">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Translation Language" formControlName="language">
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Well have a Nitrate Strip Result" formControlName="nitrateStripResult">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="How many Households rely on the Well" formControlName="householdRelyOnWell">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="How did you learn about Well Testing" formControlName="learnedOfTesting">
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field fxFlex="100">
                    <textarea matInput placeholder="Comments" formControlName="comments"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <br />
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Contact Information</span>
              </mat-card-title>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Name" formControlName="contactName">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Phone" formControlName="contactPhone">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Cell Phone" formControlName="contactCellPhone">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Email" formControlName="contactEmail">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Preferred Contact Method" formControlName="preferredContactMethod">
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="8px grid">
                <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                  <mat-card fxFlex="100">
                    <mat-card-title>
                      <span>Home Address</span>
                    </mat-card-title>
                    <div fxLayout="row wrap" fxLayoutGap="8px grid">
                      <div fxFlex="50" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Address" formControlName="address1">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Address Unit Number" formControlName="addressUnitNumber">
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="8px grid">
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="City" formControlName="city">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="State" formControlName="state">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Zip" formControlName="zip">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <mat-label>County</mat-label>
                          <mat-select id="county" name="county" formControlName="county">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.text}}">{{item.text}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="8px grid">
                      <div fxFlex="50" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Latitude" formControlName="latitude">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Longitude" formControlName="longitude">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                  <mat-card fxFlex="100">
                    <mat-card-title>
                      <span>Mailing Address</span>
                    </mat-card-title>
                    <div fxLayout="row wrap" fxLayoutGap="8px grid">
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Mailing Address" formControlName="mailingAddress">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Mailing City" formControlName="mailingCity">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Mailing State" formControlName="mailingState">
                        </mat-form-field>
                      </div>
                      <div fxFlex="25" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Mailing Zip" formControlName="mailingZip">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="none" fxLayoutGap="8px">
          <button mat-raised-button [disabled]="processing || loading || authService.isReadOnly()" color="primary" (click)="onSubmit()" title="{{buttonText}}">{{buttonText}}</button>
          &nbsp;
          <button mat-raised-button color="warn" [disabled]="processing || loading || authService.isReadOnly()" (click)="delete()" *ngIf="householdId  > 0" title="{{buttonText}}">Delete
            Household</button>
          &nbsp;
          <em fxHide fxShow.gt-sm><small *ngIf="householdId > 0">Last updated on {{household?.lastUpdated}} by
              {{household?.lastUpdatedBy}}</small>
          </em>
        </div>
      </form>
    </mat-tab>

    <!-- Well 
    <mat-tab label="Wells" *ngIf="householdId > 0">
      <br />
      <household-associations [householdId]="householdId"></household-associations>
    </mat-tab> -->

    <!-- Housing Units -->
    <mat-tab label="Housing Units" *ngIf="householdId > 0">
      <br />
      <household-associations [householdId]="householdId" [housingUnits]="true"></household-associations>
    </mat-tab>

    <!-- Interactions -->
    <mat-tab label="Interactions" *ngIf="householdId > 0">
      <br />
      <household-interactions [householdId]="householdId"></household-interactions>
    </mat-tab>

    <!-- Letters -->
    <mat-tab label="Letters" *ngIf="householdId > 0">
      <br />
      <household-letters [householdId]="householdId"></household-letters>
    </mat-tab>


  </mat-tab-group>
</div>